export default "__VITE_ASSET__U6x3LKJt__"